<div
  data-cy="title-banner"
  class="page-title-banner"
  [style.background-image]="backgroundImageStyle"
>
  <div
    data-cy="background-overlay"
    class="background-overlay"
    [style.background]="overlayGradient"
  ></div>
  <ion-grid [fixed]="true">
    <ion-row class="title-row" data-cy="title-row">
      <ion-col size="12">
        <ion-text
          id="page-title-text"
          [attr.data-cy]="'page-title-banner-text-' + pageTitle"
        >
          {{ pageTitle | uppercase }}
        </ion-text>
        <ion-icon
          *ngIf="showEllipsis"
          name="ellipsis-vertical"
          (click)="handleEllipsisClickEvent($event)"
        >
        </ion-icon>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
